import {useEffect} from 'react';

/**
 * Avantlink Script Injection across site.
 */
export function Avantlink() {
  const windowReady = typeof window !== 'undefined';

  useEffect(() => {
    var avm = document.createElement('script');
    avm.type = 'text/javascript';
    avm.async = true;
    avm.src =
      ('https:' == document.location.protocol ? 'https://' : 'http://') +
      'cdn.avmws.com/1021253/';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(avm, s);
  }, [windowReady]);

  return null;
}
